<template>
    <div style="text-align: left;margin-top: 15vw;padding-left: 3vw" class="animated slideInLeft">
        <div class="navList">
            <span class="number">1</span>
            <p><img src="../assets/img/navImg/aphv.svg" alt=""></p>
            <span>APHV</span>
        </div>
        <div class="navList">
            <span class="number">2</span>
            <p><img src="../assets/img/navImg/speed.svg" alt=""></p>
            <span>速度报告</span>
        </div>
        <div class="navList">
            <span class="number">3</span>
            <p><img src="../assets/img/navImg/antro.svg" alt=""></p>
            <span>基础报告</span>
        </div>
        <div class="navList">
            <span class="number">4</span>
            <p><img src="../assets/img/navImg/yoyo.svg" alt=""></p>
            <span>耐力测试报告</span>
        </div>
        <div class="navList">
            <span class="number">5</span>
            <p><img src="../assets/img/navImg/agility.svg" alt=""></p>
            <span>敏捷度报告</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "body_report",
        computed: {
            paramsCommandFn() {
                return this.$store.state.paramsCommand;
            }
        },
        data(){
            return{
                routerList:this.$aiJson.bodyRouter,//体测详细路由
            }
        },
        watch:{
            paramsCommandFn:{
                handler(val,old){
                    let command = this.routerList;//模块命令比如 训练报告
                    let flag = 0;//是否触功能指令 训练报告

                    for (let i = 0; i < command.length; i++) {
                        if (eval('/' +  this.$aiJson.itemNum[i] + '号' + '/gi').test(val)) {
                            this.$store.dispatch("setFlag", '1_' + new Date().getTime());//vuex改变识别信息---好的
                            clearInterval(this.$parent.$parent.timer);
                            this.$parent.$parent.imgAi(this.$imgJson.taskAiImgArr);
                            this.$store.dispatch("setRouter", {path:command[i].url,name:command[i].name,goType:1});//vuex改变路由
                            this.$store.state.speakStr=command[i].speak;
                            flag = 1;
                            return false;
                        } else {
                            flag = 0;
                        }
                    }

                    for (let p = 0; p < command.length; p++) {
                        for (let g = 0; g < command[p].identifyWord.length; g++) {//判断模块指令是否存在
                            if (eval('/' + command[p].identifyWord[g] + '/gi').test(val)) {
                                if(this.$store.state.router.name!=command[p].name){
                                    this.$store.dispatch("setFlag", '1_' + new Date().getTime());//vuex改变识别信息---好的
                                    clearInterval(this.$parent.$parent.timer);
                                    this.$parent.$parent.imgAi(this.$imgJson.taskAiImgArr);
                                    this.$store.dispatch("setRouter", {path:command[p].url,name:command[p].name,goType:1});//vuex改变路由
                                    this.$store.state.speakStr=command[p].speak;
                                }
                                flag = 1;
                                return;
                            }else {
                                flag = 0;
                            }
                        }
                    }


                    if (!flag){
                        this.$store.dispatch("setFlag", '0_' + new Date().getTime());//vuex改变识别信息
                    }
                },
                deep:true
            },
        },
        mounted() {
            this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl(this.$store.state.speakStr),true,true,2);
            this.$store.state.promptMsg=this.$route.meta.promptMsg;
        },
        methods:{
            trainingFn(){
                this.$router.push({
                    path:'/about/assessmentReport',
                    name:'assessmentReport'
                });
            }
        },
    }
</script>

<style scoped lang="less">
    .navList{
        background-image: url("../assets/img/updateImg/menuBg.svg");
        background-repeat: no-repeat;
        background-size: 100% auto;
        background-position: center;
        display: inline-block;
        width: calc(20% - 2.5vw);
        margin-right: 1.5vw;
        margin-bottom: 1.5vw;
        text-align: center;
        color: #fff;
        font-size: 28px;
        padding-bottom: 3.5vw;
        padding-top: 2.5vw;
        border-radius: 3px;
        position: relative;
        img{
            width: 50%;
        }
        span{
            padding-top: 3vw;
        }

        .number{
            padding-top: 0 !important;
            border: 2px solid rgba(255, 255, 255, 0.3);
            width: 2vw;
            height: 2vw;
            background-color: #42A5F5;
            border-radius: 50%;
            text-align: center;
            line-height: 2vw;
            font-size: 34px;
            position: absolute;
            font-family: akrobatBold;
            top: .5vw;
            left: .5vw;
            z-index: 1;
            color: #fff;
        }
    }
</style>
